<!-- eslint-disable vue/no-v-html -->
<template>
	<div id="overview" class="row position-relative">
		<ComponentLoader v-if="!ready" />
		<template v-if="ready">
			<div ref="overviewTitle" class="col-12">
				<template v-if="!asSearchResult && !categoryIsPdp">
					<div class="c c-productoverview__intro">
						<div v-if="categoryImage != ''" class="c-productoverview__intro--img">
							<img :src="categoryImage" :alt="categoryTitle" class="img-fluid" />
						</div>
						<div class="c-productoverview__intro--text">
							<h1>{{ categoryTitle }}</h1>
							<div v-html="getCategoryText" />
						</div>
					</div>
					<div class="c"><hr /></div>
				</template>
				<div ref="overviewProducts" class="c-productoverview">
					<template v-if="itemsWithNetPriceAndQty.length > 0">
						<div class="c-productoverview__options d-flex align-items-center justify-content-between">
							<div class="c-productoverview__amount">
								<h2>
									<template v-if="count === 1">
										<template v-if="categoryIsPdp"> {{ count }} product variant </template>
										<template v-else> {{ count }} product </template>
									</template>
									<template v-else>
										<template v-if="categoryIsPdp"> {{ count }} product varianten </template>
										<template v-else> {{ count }} producten </template>
									</template>
								</h2>
							</div>
							<div class="c-productoverview__sort">
								<SelectControl
									:value="'' + itemsPerPage"
									codename="Aantal per pagina"
									label="Aantal per pagina"
									:options="[
										{ label: '12', value: '12' },
										{ label: '24', value: '24' },
										{ label: '48', value: '48' },
										{ label: '96', value: '96' }
									]"
									:inline="true"
									class="c-productoverview__sort--select"
									@input="setItemsPerPage($event)"
								/>
								<button type="button" :class="['c-productoverview__sort--list', { active: gridView }]" @click="setGridView(true)">
									<i class="fal fa-th" />
								</button>
								<button type="button" :class="['c-productoverview__sort--list', { active: !gridView }]" @click="setGridView(false)">
									<i class="fal fa-bars" />
								</button>
							</div>
						</div>
						<Pagination v-if="pages > 1" v-model="currentPage" container-class="c-pagination" :page-count="pages" :click-handler="goToPage" page-text="Pagina" from-text="van" next-text="tot" />
						<div class="c c-productoverview__items" :data-view="gridView ? 'grid' : 'list'">
							<div v-for="item in itemsWithNetPriceAndQty" :key="item.CodeName" class="c-productoverview__items--item">
								<Product
									:artikel-nummer="item.ArticleCode"
									:artikel-titel="item.ShortDescription"
									:detail-url="item.DetailUrl"
									:in-stock="true"
									:price="item.GrossPriceInfoPrice"
									:price-promo="item.NetPrice"
									:grid-view="gridView"
									:image-url="imageUrl(item)"
									:is-logged-in="isLoggedIn"
									:price-quantity="item.GrossPriceInfoPriceQuantity"
									:price-unit="item.GrossPriceInfoPriceUnitCode"
									:hide-price-and-shopping-cart="asSearchResult"
									:is-loading-promo-price="isLoadingPromoPrice"
									:is-product-detail-page="productDetailCode !== ''"
									:is-verzendbaar="item.Verzendbaar"
								/>
							</div>
						</div>
					</template>
					<div v-else class="c c-productoverview__noresults">
						<slot name="noresults">
							<div class="text">
								<p v-html="noResultsText"></p>
							</div>
						</slot>
					</div>
					<Pagination v-if="pages > 1" v-model="currentPage" :page-count="pages" :click-handler="goToPage" page-text="Pagina" from-text="van" next-text="tot" />
				</div>
			</div>
		</template>
	</div>
</template>
<script>
// import { mapState } from 'vuex'
// import forms from '~/plugins/forms.client.js'
import azuresearch from '../plugins/azureSearch';
import axios from 'axios';
import { setFacets, ConcatFilters, GetFacetFilter } from '../plugins/azureSearch/helpers';
import Pagination from '../components/general/Pagination.vue';
import Product from '../components/general/Product.vue';
import SelectControl from '../components/forms/controls/SelectControl.vue';
import ComponentLoader from '../components/general/ComponentLoader.vue';
export default {
	components: {
		ComponentLoader,
		Pagination,
		Product,
		SelectControl
	},
	props: {
		searchOverviewSettings: {
			type: Object,
			required: true
		},
		categoryTitle: {
			type: String,
			required: false,
			default: ''
		},
		categoryIsPdp: {
			type: Boolean,
			required: false,
			defaullt: false
		},
		categoryText: {
			type: String,
			required: false,
			default: ''
		},
		categoryImage: {
			type: String,
			required: false,
			default: '/Assets/Images/noimage.png'
		},
		categorySettings: {
			type: Object,
			required: false,
			default: () => {}
		},
		azureSearchIndexName: {
			type: String,
			required: false,
			default: 'test'
		},
		asSearchResult: {
			type: Boolean,
			required: false,
			default: false
		},
		noResultsText: {
			type: String,
			required: false,
			default: 'Er zijn geen resultaten gevonden.'
		},
		isLoggedIn: {
			type: Boolean,
			required: true
		},
		productDetailCode: {
			type: String,
			required: false,
			default: ''
		}
	},
	data() {
		return {
			...this.searchOverviewSettings,
			netPrices: [],
			articleImages: [],
			isLoadingPromoPrice: false,
			selectedCompany: ''
		};
	},
	computed: {
		maxPages() {
			if (this.searchSettings.searchRequest.top === 0) {
				return 0;
			}
			return Math.ceil(this.count / this.searchSettings.searchRequest.top);
		},
		pages() {
			return Math.ceil(this.count / (this.itemsPerPage || this.pageSize));
		},
		itemsWithNetPriceAndQty() {
			const updatedItems = this.items.map(item => {
				const netPrice = this.netPrices.find(netPrice => item.Code === netPrice.Code);
				const matchingImage = this.articleImages.find(image => image.Item1 === item.deepestCategory);

				return {
					...item,
					Image: matchingImage && !item.Image ? matchingImage.Item2 : item.Image,
					NetPrice: netPrice ? netPrice.CalculatedNetPrice : 0,
					QuantityNijv: 0,
					QuantityZw: 0
				};
			});

			// Sorteer items op artikelcode
			const sortedItems = updatedItems.sort((a, b) => {
				if (a.ArticleCode < b.ArticleCode) {
					return -1;
				}
				if (a.ArticleCode > b.ArticleCode) {
					return 1;
				}
				return 0;
			});

			return sortedItems.filter(item => item.Code !== this.productDetailCode);
		},
		getCategoryText() {
			var text = this.categoryText;
			text = text.replaceAll('<p>- ', '<p>&bull;&nbsp; ');
			text = text.replaceAll('<p><span>- ', '<p><span>&bull;&nbsp; ');
			return text;
		}
	},
	created() {
		this.productOverviewClient = axios.create({
			baseURL: '/api/productoverview' // = TODO
		});
		this.productOverviewClient.defaults.headers.common['Content-Type'] = 'application/json';
		this.productOverviewClient.defaults.timeout = 0;
		this.productOverviewClient.defaults.method = 'post';
		this.searchSettings.apiSettings = {
			apiVersion: '2017-11-11',
			corsSettings: [],
			indexName: 'aquaco-abp-articles-' + this.azureSearchIndexName,
			searchServiceAdminApiKey: '5B19F67CFEA1A870B28F3BCD4CD5C9B6',
			searchServiceName: null,
			searchServiceQueryApiKey: '3ADAC7C0EEF51BB4DF3D19C93C704A02',
			url: 'https://prod-aquaco-search.search.windows.net'
		};
		this.searchApi = new azuresearch.AzureSearchApi(this.searchSettings);
		this.search();
	},
	mounted() {
		if (localStorage.itemsPerPage) {
			if (this.itemsPerPage !== localStorage.itemsPerPage) {
				this.itemsPerPage = localStorage.itemsPerPage;
				this.setItemsPerPage(this.itemsPerPage);
			}
		} else {
			this.setItemsPerPage(48);
		}
		if (localStorage.gridView) {
			const gridViewVal = localStorage.getItem('gridView');
			this.gridView = JSON.parse(gridViewVal) === true;
		}
	},
	methods: {
		toggleBodyClass(addRemoveClass, className) {
			const el = document.body;
			if (addRemoveClass === 'addClass') {
				el.classList.add(className);
			} else {
				el.classList.remove(className);
			}
		},
		imageUrl(item) {
			return item.Image || this.categoryImage;
		},
		setItemsPerPage(event) {
			localStorage.itemsPerPage = event;
			this.searchSettings.searchRequest.top = event;
			this.searchSettings.pageSize = event;
			this.currentPage = 1;
			this.itemsPerPage = Number(event);
			this.search();
		},
		setGridView(event) {
			this.gridView = event;
			localStorage.gridView = event;
		},
		sort(event) {
			this.searchSettings.searchRequest.orderBy = event;
			this.currentPage = 1;
			this.$store.$router.push({
				query: { ...this.$nuxt._route.query, page: 1 }
			});
			this.search();
		},
		createSearchRequest() {
			const searchRequest = new azuresearch.AzureSearchRequest(this.searchSettings.searchRequest);
			const predefinedfilter = this.searchSettings.searchRequest.filter;
			const facetfilters = GetFacetFilter(this.checkedFacets, this.facetSettings, this.complexFacetParents, this.complexFacetNames);
			const filter = ConcatFilters([predefinedfilter, facetfilters]);
			this.searchSettings.searchRequest.skip = searchRequest.skip = (this.currentPage - 1) * this.searchSettings.searchRequest.top;
			searchRequest.filter = filter;
			searchRequest.orderBy = 'search.score() desc, ShortDescription asc'; // Order by score and then by shortdescription.
			return searchRequest;
		},
		async search(event) {
			const searchRequest = this.createSearchRequest();
			if (event) event.preventDefault();
			await this.executeSearch(searchRequest);
		},
		async getNetPrices(articles) {
			// Haal het geselecteerde bedrijf uit de localstorage
			this.selectedCompany = localStorage.getItem('geselecteerdBedrijf') || '';

			const articleCodes = articles.map(article => article.Code);
			this.isLoadingPromoPrice = true;
			this.productOverviewClient
				.post('/netprices', {
					articleCodes,
					selectedCompany: this.selectedCompany
				})
				.then(netPrices => {
					this.netPrices = netPrices.data;
					this.isLoadingPromoPrice = false;
				})
				.catch(() => {
					this.isLoadingPromoPrice = false;
				});
		},
		getFallbackImages(articles) {
			articles.forEach(article => {
				const lastCombinedParentKey = article.CombinedParentKeys[article.CombinedParentKeys.length - 1];
				const splitResult = lastCombinedParentKey.split('|');
				article.deepestCategory = splitResult[splitResult.length - 1];
			});

			this.isLoadingPromoPrice = true;

			const deepestCategories = articles.map(article => article.deepestCategory);

			this.productOverviewClient
				.post('/articleimages', {
					deepestCategories
				})
				.then(data => {
					this.articleImages = data.data;
				});
		},
		async executeSearch(searchRequest) {
			try {
				const response = await this.searchApi.search(searchRequest);
				this.facets = setFacets(this.facets, response.data['@search.facets'], this.initialSearch, this.checkedFacets);
				this.items = response.data.value;
				// Don't wait for these calls because it can take some time.
				if (!this.asSearchResult) {
					// Haal het geselecteerde bedrijf uit de localstorage
					this.selectedCompany = localStorage.getItem('geselecteerdBedrijf') || '';
					this.getNetPrices(this.items, this.selectedCompany);
				} else {
					this.getFallbackImages(this.items);
				}
				this.ready = true;
				this.count = response.data['@odata.count'];
				if (this.productDetailCode !== '') this.count--;
				this.initialSearch = false;
				this.setComplexFacets();
			} catch (error) {
				console.log(error);
			}
		},
		setComplexFacets() {
			this.facets = Object.assign({}, this.facets);
			this.complexFacetNames = [];
			this.complexFacetParents = [];
			const complexFacets = this.facetSettings.filter(facetSetting => facetSetting.value === 'Complex');
			// Add complex facets to this.facets
			let complexFieldId = 0;
			for (const complexFacet of complexFacets) {
				const complexFacetValues = this.facets[complexFacet.key];
				for (const complexFacetValue of complexFacetValues) {
					const splittedComplexFacet = complexFacetValue.value.split('|');
					const title = splittedComplexFacet[0];
					const value = splittedComplexFacet[1];
					let fieldName = Object.keys(this.complexFacetNames).find(key => this.complexFacetNames[key] === title);
					if (typeof fieldName === 'undefined') {
						fieldName = `complex${complexFieldId}`;
						complexFieldId++;
					}
					this.complexFacetNames[fieldName] = title;
					this.complexFacetParents[fieldName] = complexFacet.key;
					if (typeof this.facets[fieldName] === 'undefined') {
						this.facets[fieldName] = [];
					}
					const newFacetValue = {
						count: complexFacetValue.count,
						value
					};
					const previousFacetValue = this.facets[fieldName].find(fv => fv.value === newFacetValue.value);
					if (previousFacetValue) {
						previousFacetValue.count = newFacetValue.count;
					} else {
						this.facets[fieldName].push(newFacetValue);
					}
				}
			}
			// Add complex facets to this.searchSettings.facets
			for (const property in this.complexFacetNames) {
				const title = this.complexFacetNames[property];
				const newFacet = {
					title: this.complexFacetNames[property],
					field: property,
					textTop: '',
					textBottom: '',
					tooltipText: '',
					valueType: 0,
					facetMode: 0,
					expanded: true,
					showMore: false,
					showMoreAfter: 5,
					facetValueOverrides: null,
					sliderSettings: null
				};
				const previousFacet = this.searchSettings.facets.find(facet => facet.title === title);
				if (!previousFacet) this.searchSettings.facets.push(newFacet);
			}
			this.complexFacetsLoaded = true;
		},
		goToPage(pageNumber) {
			if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= this.maxPages) {
				this.currentPage = pageNumber;
				this.search();
				const overviewTitle = this.$refs.overviewTitle;
				if (overviewTitle != null) {
					overviewTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		},
		scrollToProducts(e) {
			e.preventDefault();
			const prods = this.$refs.overviewProducts;
			if (prods != null) {
				prods.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		},
		isShowMore(showMoreAfter, filteredFacets) {
			if (filteredFacets && filteredFacets.length > showMoreAfter) return true;
		},
		facetClicked() {
			this.filtered = true;
		},
		resetFacets() {
			this.checkedFacets = [];
		},
		resetAll() {
			this.complexFacetNames = {};
			this.facets = {};
			this.complexFacetParents = [];
			this.checkedFacets = [];
			const complexFacetSettings = this.searchSettings.facets.filter(facet => facet.field.startsWith('complex'));
			for (const complexFacetSetting of complexFacetSettings) {
				const index = this.searchSettings.facets.findIndex(e => e.field === complexFacetSetting.field);
				this.searchSettings.facets.splice(index, 1);
			}
		}
	}
};
</script>
